import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { theme } from './styles/theme';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import VisionAim from './pages/VisionAim/VisionAim';

function App() {
  const [language, setLanguage] = useState('mm');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'mm' : 'en');
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh'
        }}>
          <Navbar language={language} toggleLanguage={toggleLanguage} />
          <Box sx={{ flex: 1 }}>
            <Routes>
              <Route path="/vision-aim" element={<VisionAim language={language} />} />
              {/* Add other routes here */}
            </Routes>
          </Box>
          <Footer language={language} />
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;

